module.exports = __webpack_public_path__ + "static/media/home-service-slider-12.853cb8b6.jpg";